import React, { useRef } from 'react'
import Slider from 'react-slick'
import { withTheme, createComponent } from '@ycos/fela'
import Block from '../common/Block'
import NavigationButton from './NavigationButton'

const arrowAdditionalStyles = {
  position: 'absolute',
  zIndex: 1,
  top: '7vw',
  '@supports (top: min(9vw, 134px))': {
    top: 'min(9vw, 134px) !important'
  }
}

const SliderContainer = createComponent('SliderContainer', () => ({
  position: 'relative',
  width: '100%',
  overflow: 'hidden'
}))

const SliderInnerWrapper = createComponent('SliderInnerWrapper', ({ theme }) => {
  return {
    width: `calc(100% + ${theme.spacingMultiplier * 3}px)`,
    marginLeft: `-${theme.spacingMultiplier * 3}px`,
    textAlign: 'left'
  }
})

const NavigationButtonNext = createComponent(
  'NavigationButtonNext',
  ({ theme }) => {
    const isRtl = theme.direction === 'rtl'
    return {
      ...arrowAdditionalStyles,
      right: isRtl ? 'unset' : 0,
      left: isRtl ? `${theme.spacingMultiplier * 3}px` : 'unset',
      transform: 'scaleX(-1)'
    }
  },
  NavigationButton,
  ['dataAutomation', 'onClick', 'additionalStyles', 'disabled', 'runBounceAnimation', 'runButtonAnimationFade', 'ariaLabel']
)

const NavigationButtonPrevious = createComponent(
  'NavigationButtonPrevious',
  ({ theme }) => {
    const isRtl = theme.direction === 'rtl'

    return {
      ...arrowAdditionalStyles,
      left: isRtl ? 'unset' : `${theme.spacingMultiplier * 3}px`,
      right: isRtl ? 0 : 'unset'
    }
  },
  NavigationButton,
  ['dataAutomation', 'onClick', 'additionalStyles', 'disabled', 'runBounceAnimation', 'runButtonAnimationFade', 'ariaLabel']
)

const NextButton = ({ className, style, onClick }) => (
  <NavigationButtonNext
    className={className}
    dataAutomation="carousel-next-button"
    ariaLabel="Next slide"
    onClick={onClick}
    style={style}
    disabled={className.includes('slick-disabled')}
  />
)

const PreviousButton = ({ className, style, onClick }) => (
  <NavigationButtonPrevious
    className={className}
    dataAutomation="carousel-previous-button"
    ariaLabel="Previous slide"
    onClick={onClick}
    style={style}
    disabled={className.includes('slick-disabled')}
  />
)

const BlockWrapper = createComponent('BlockWrapper', ({ theme }) => ({
  paddingLeft: `${theme.spacingMultiplier * 3}px`
}))

const DesktopCarousel = ({ items, imageSphere, lazy, theme }) => {
  const carouselRef = useRef(null)
  const SLIDES_PER_SLIDE = 3
  const isRtl = theme.direction === 'rtl'
  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: SLIDES_PER_SLIDE,
    slidesToScroll: SLIDES_PER_SLIDE,
    initialSlide: isRtl ? items.length - SLIDES_PER_SLIDE : 0,
    speed: 500,
    draggable: false,
    swipe: false,
    nextArrow: <NextButton />,
    prevArrow: <PreviousButton />
  }
  const slideItems = isRtl ? [...items].reverse() : items

  return (
    <SliderContainer>
      <SliderInnerWrapper>
        <Slider {...settings} ref={carouselRef}>
          {slideItems &&
            slideItems.map((item, index) => (
              <BlockWrapper dir={isRtl ? 'rtl' : 'ltr'}>
                <Block key={`rewards-slide-${index}`} item={item} imageSphere={imageSphere} imageProps={{ lazy }} />
              </BlockWrapper>
            ))}
        </Slider>
      </SliderInnerWrapper>
    </SliderContainer>
  )
}

export default withTheme(DesktopCarousel)
